import React from 'react';

import { createInternalContext } from '~/shared/contexts/createInternalContext';
import { Frontmatter } from '~/gamePageTypes';

export type { Frontmatter, SectionItem, SectionType, SocialLink, SocialType } from '~/gamePageTypes';

export const [FrontmatterProvider, useFrontmatter] = createInternalContext<Frontmatter>({
  name: 'Frontmatter',
});
